import english from "@/locales/eng";
import store from "@/store/index";

export default {
  methods: {
    locale(key) {
      if (!this.$store.state.Tmp || this.$store.state.Tmp.LangID == undefined)
        return key;
      //   console.log(this.$store.state.Tmp.LangID, { english });
      if (english[key] == undefined) return key;
      if (english[key][this.$store.state.Tmp.LangID] == undefined) return key;
      return english[key][this.$store.state.Tmp.LangID];
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/locale.js